import { FerryTripEntity } from 'Models/Entities';
import { useEffect } from 'react';
import { TicketsTabTrip } from 'Services/Api/_HumanWritten/BookingWizardDataService';

import { isNotNullOrUndefined } from 'Util/TypeGuards';
import { store } from 'Models/Store';
import { BookingWizardData } from '../../../BookingWizardData/BaseBookingWizardData';

/**
 * Handles ticket deselection when ferry filter start/end locations are changed.
 * Ensures the selected ticket aligns with the selected locations.
 */
export const useTicketDeselectionForClosedTrip = (
	wizardData: BookingWizardData,
	saveChanges: (newData: BookingWizardData) => void,
	selectedDepartingTrip?: FerryTripEntity | TicketsTabTrip,
	selectedReturningTrip?: FerryTripEntity | TicketsTabTrip,
) => {
	useEffect(() => {
		// Whoever holds OverrideBookingRestrictions may book a closed trip — the server skips the closed
		// check for them — so switching tab must not throw away a trip they have already picked. Same rule
		// as useTripValidation.
		if (store.can('OverrideBookingRestrictions')) {
			return;
		}

		let changeDetected = false;
		const newData = new BookingWizardData({ ...wizardData });
		switch (wizardData.tabSelected) {
			case 'vehicle':
				if (isNotNullOrUndefined(selectedDepartingTrip) && selectedDepartingTrip?.vehicleBookingsClosed) {
					changeDetected = true;
					newData.departureTicketId = '';
					newData.departingJourney = undefined;
				}
				if (isNotNullOrUndefined(selectedReturningTrip) && selectedReturningTrip.vehicleBookingsClosed) {
					changeDetected = true;
					newData.returningTicketId = '';
					newData.returningJourney = undefined;
				}
				break;
			case 'freight':
				if (isNotNullOrUndefined(selectedDepartingTrip) && selectedDepartingTrip?.freightBookingsClosed) {
					changeDetected = true;
					newData.departureTicketId = '';
					newData.departingJourney = undefined;
				}
				if (isNotNullOrUndefined(selectedReturningTrip) && selectedReturningTrip.freightBookingsClosed) {
					changeDetected = true;
					newData.returningTicketId = '';
					newData.returningJourney = undefined;
				}
				break;
			default:
				if (isNotNullOrUndefined(selectedDepartingTrip) && selectedDepartingTrip?.passengerBookingsClosed) {
					changeDetected = true;
					newData.departureTicketId = '';
					newData.departingJourney = undefined;
				}
				if (isNotNullOrUndefined(selectedReturningTrip) && selectedReturningTrip.passengerBookingsClosed) {
					changeDetected = true;
					newData.returningTicketId = '';
					newData.returningJourney = undefined;
				}
				break;
		}

		if (changeDetected) {
			saveChanges(newData);
		}
	}, [wizardData.tabSelected]);
};
